/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import {
  ObservableCollection, ObservableCollectionEntry, ObservableCollectionOptions
} from './observable-collection.util';

export class ObservableMap<T> extends ObservableCollection<string, T> {
  private entryMap = new Map<string, ObservableCollectionEntry<string, T>>();

  constructor(values?: object, options?: ObservableCollectionOptions) {
    super(options);
    if (values) {
      this.setValues(values, { exclusive: true, force: true, silent: true });
    }
  }

  get size(): number {
    return this.entryMap.size;
  }

  toJSON(): { [key: string]: T } {
    const result = {};
    this.entryMap.forEach((entry: ObservableCollectionEntry<string, T>) => {
      const value: any = entry.value;
      result[entry.key] = value && typeof value.toJSON === 'function' ? value.toJSON() : value;
    });
    return result;
  }

  protected internalEntries(): IterableIterator<ObservableCollectionEntry<string, T>> {
    return this.entryMap.values();
  }

  protected internalHasEntry(key: string) {
    return this.entryMap.has(key.toString());
  }

  protected internalGetEntry(key: string): ObservableCollectionEntry<string, T> {
    return this.entryMap.get(key.toString());
  }

  protected internalSetEntry(entry: ObservableCollectionEntry<string, T>): void {
    if (entry.value === undefined) {
      this.entryMap.delete(entry.key.toString());
    } else {
      this.entryMap.set(entry.key.toString(), entry);
    }
  }

  protected internalRemoveEntry(key: string): boolean {
    return this.entryMap.delete(key.toString());
  }

}
